import { Eye, EyeOff } from 'lucide-react'
import { forwardRef, useState } from 'react'

import { TextField, TextFieldProps } from './TextField'

export const PasswordInput = forwardRef<HTMLInputElement, TextFieldProps>(({ ...props }, ref) => {
  const [showPassword, setShowPassword] = useState(false)
  return (
    <TextField
      type={showPassword ? 'text' : 'password'}
      trailingIcon={
        <button
          type='button'
          onClick={() => setShowPassword(!showPassword)}
          className='text-gray-400 transition-colors hover:text-gray-600'
        >
          {showPassword ? <EyeOff className='size-4' /> : <Eye className='size-4' />}
        </button>
      }
      {...props}
      ref={ref}
    />
  )
})
PasswordInput.displayName = 'PasswordInput'
